import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

export default function Footer() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleNav = (path: string) => {
    navigate(path);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="w-full bg-secondary-100/70 border-t border-secondary-200/50">
      <div className="w-full px-4 md:px-6 py-10 md:py-14">
        <div className="max-w-6xl mx-auto">
          <div className="flex flex-col md:flex-row items-center justify-between gap-6">
            {/* Logo */}
            <button
              onClick={() => handleNav('/')}
              className="flex items-center gap-2.5 cursor-pointer hover:opacity-80 transition-opacity"
            >
              <span className="w-8 h-8 flex items-center justify-center bg-primary-500 text-background-50 rounded-lg">
                <i className="ri-restaurant-2-line text-lg" />
              </span>
              <span className="font-heading text-xl font-bold text-foreground-950">
                BIOLA
              </span>
            </button>

            {/* Links */}
            <div className="flex items-center gap-6 flex-wrap justify-center">
              <button
                onClick={() => handleNav('/')}
                className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors cursor-pointer"
              >
                {t('nav.home')}
              </button>
              <button
                onClick={() => handleNav('/about')}
                className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors cursor-pointer"
              >
                {t('nav.about')}
              </button>
              <button
                onClick={() => handleNav('/contact')}
                className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors cursor-pointer"
              >
                {t('nav.contact')}
              </button>
              <button
                onClick={() => handleNav('/privacy')}
                className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors cursor-pointer"
              >
                {t('nav.privacy')}
              </button>
            </div>

            {/* Social */}
            <div className="flex items-center gap-2.5">
              <a
                href="https://www.instagram.com/biola.ae?stkn=Y3YwenRzYmRzcXVk"
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 flex items-center justify-center rounded-full bg-background-50 text-foreground-600 hover:bg-primary-500 hover:text-background-50 hover:-translate-y-0.5 hover:scale-110 transition-all duration-200 cursor-pointer"
                aria-label="Instagram"
              >
                <i className="ri-instagram-line" />
              </a>
              <a
                href="https://www.tiktok.com/@biola.ae?_r=1&_t=ZS-996Cv3YEg7g"
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 flex items-center justify-center rounded-full bg-background-50 text-foreground-600 hover:bg-primary-500 hover:text-background-50 hover:-translate-y-0.5 hover:scale-110 transition-all duration-200 cursor-pointer"
                aria-label="TikTok"
              >
                <i className="ri-tiktok-line" />
              </a>
            </div>
          </div>

          <div className="mt-8 pt-6 border-t border-secondary-200/40 text-center">
            <p className="text-sm text-foreground-500">
              {t('footer.rights', { year: new Date().getFullYear() })}
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}